import { applyMiddleware, combineReducers, legacy_createStore } from "redux";
import thunk from "redux-thunk";
import { reducer as AppReducer } from "./app/reducer";

const rootReducer = combineReducers({ AppReducer });

export const store = legacy_createStore(rootReducer, applyMiddleware(thunk));
